import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap, Award } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

export const AboutIntro = () => {
    return (
        <section data-testid="about-intro" className="bg-background">
            <div className="container-prose py-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
                    <div className="lg:col-span-5">
                        <div className="overline">About Finance Wealth</div>
                        <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05] text-[#1A362B] font-medium">
                            Personal finance advice, the way it should be.
                        </h2>
                        <div className="divider-thin my-8" />
                        <p className="text-[#1C1C1C]/75 leading-relaxed">
                            Finance Wealth is led by <strong className="text-[#1A362B] font-medium">{BUSINESS.broker}</strong> —
                            a qualified mortgage broker helping borrowers Australia-wide, online and over the phone.
                            With a background in accounting and finance, Gurpreet brings a structured, transparent
                            approach to every loan: clear options, honest advice, and an unwavering commitment to your
                            long-term outcome.
                        </p>

                        <Link to="/about" data-testid="about-read-more" className="mt-10 inline-flex items-center gap-2 text-[#1A362B] font-medium border-b border-[#C69C6D] pb-1 hover:gap-3 transition-all">
                            Read Gurpreet's full story <ArrowRight className="w-4 h-4" />
                        </Link>
                    </div>

                    <div className="lg:col-span-7">
                        <div className="bg-[#1A362B] text-white p-10 md:p-12 rounded-sm relative">
                            <div className="font-serif text-3xl text-[#E8C997]">{BUSINESS.broker}</div>
                            <div className="text-xs tracking-[0.25em] uppercase text-white/60 mt-2">{BUSINESS.role}</div>
                            <div className="divider-thin my-6 bg-[#C69C6D]" />
                            <p className="text-white/80 leading-relaxed">
                                Whether you're buying your first home, refinancing, building a portfolio or financing
                                a business — we will find the right lender, structure and rate for your goals.
                            </p>

                            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div className="bg-white/5 border border-white/10 p-5 rounded-sm">
                                    <Award className="w-5 h-5 text-[#C69C6D]" />
                                    <div className="text-[10px] tracking-[0.25em] uppercase text-[#C69C6D] font-semibold mt-3">Credentials</div>
                                    <div className="mt-1 font-serif text-lg text-white">Diploma · Finance &amp; Mortgage Broking</div>
                                </div>
                                <div className="bg-white/5 border border-white/10 p-5 rounded-sm">
                                    <GraduationCap className="w-5 h-5 text-[#C69C6D]" />
                                    <div className="text-[10px] tracking-[0.25em] uppercase text-[#C69C6D] font-semibold mt-3">Background</div>
                                    <div className="mt-1 font-serif text-lg text-white">BCom · Accounting &amp; Finance</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutIntro;
